import React from 'react'
import { wholesaleIntro } from './content'
import type { Lang } from './types'

interface WholesaleIntroSplitV2Props {
  currentLang: Lang
}

/**
 * Barista Map style intro split: portrait image left, eyebrow + title +
 * body + CTA right. Body content is preserved verbatim from the original
 * WholesalePage to keep SEO body copy intact.
 */
const WholesaleIntroSplitV2: React.FC<WholesaleIntroSplitV2Props> = ({
  currentLang,
}) => {
  return (
    <section className="bg-[#F7F4EE] py-16 md:py-24">
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-10 px-6 md:grid-cols-2 md:gap-16 md:px-10">
        {/* Image */}
        <div className="aspect-[4/5] w-full overflow-hidden bg-black/5">
          <img
            src={wholesaleIntro.image}
            alt={wholesaleIntro.imageAlt[currentLang]}
            className="h-full w-full object-cover"
          />
        </div>

        {/* Text */}
        <div className="flex flex-col justify-center">
          <p
            className="mb-4 text-[12px] tracking-[0.22em] text-black/65"
            style={{
              fontFamily: "'EB Garamond', serif",
              fontStyle: 'italic',
              fontWeight: 400,
            }}
          >
            {wholesaleIntro.eyebrow[currentLang]}
          </p>

          <h2
            className="mb-8 text-black"
            style={{
              fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
              fontWeight: 400,
              fontSize: 'clamp(1.875rem, 3.4vw, 2.75rem)',
              letterSpacing: '0.03em',
              lineHeight: 1.2,
            }}
          >
            {wholesaleIntro.title[currentLang]}
          </h2>

          <div
            className="space-y-5 text-[14px] leading-loose text-black/75"
            style={{
              fontFamily: "'Noto Serif TC', 'Noto Sans TC', sans-serif",
              fontWeight: 300,
              letterSpacing: '0.03em',
            }}
          >
            {wholesaleIntro.body[currentLang]
              .split('\n\n')
              .map((para, i) => (
                <p key={i}>{para}</p>
              ))}
          </div>

          <a
            href={wholesaleIntro.ctaHref}
            className="mt-10 inline-flex w-fit items-center border-b border-black pb-1 text-[13px] tracking-[0.2em] text-black transition-opacity hover:opacity-60"
            style={{
              fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
              fontWeight: 400,
            }}
          >
            {wholesaleIntro.ctaLabel[currentLang]}
          </a>
        </div>
      </div>
    </section>
  )
}

export default WholesaleIntroSplitV2
